module.exports = __webpack_public_path__ + "static/media/aurelionsol.0c8fba8b.png";